module.exports = __webpack_public_path__ + "static/media/MINI-TEST-COUNT-1.cf17293b.png";